import { User, Phone, Mail } from "lucide-react";
import { FormInput } from "./FormInput";

const ContactInfoStep = ({ formData, onChange }) => {
  return (
    <div className="space-y-6 animate-fade-in">
      <h2 className="text-xl font-bold text-white flex items-center gap-2">
        <User className="w-5 h-5 text-[#D4AF37]" />
        Contact Information
      </h2>
      
      <div className="space-y-4">
        <FormInput
          label="Full Name"
          required
          icon={User}
          type="text"
          name="full_name"
          value={formData.full_name}
          onChange={onChange}
          placeholder="Enter your full name"
        />
        
        <FormInput
          label="Phone Number"
          required
          icon={Phone}
          type="tel"
          name="phone_number"
          value={formData.phone_number}
          onChange={onChange}
          placeholder="(555) 555-5555"
        />
        
        <FormInput
          label="Email Address"
          required
          icon={Mail}
          type="email"
          name="email"
          value={formData.email}
          onChange={onChange}
          placeholder="your@email.com"
        />
      </div>
    </div>
  );
};

export default ContactInfoStep;
